import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TraineeDetailsSidebar from "components/TraineeDetails/TraineeDetailsSidebar/TraineeDetailsSidebar";
import classes from "./TraineeDetails.module.css";
import { getTraineeDetails } from "../../services/userServices";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import EmployeeDetails from "../../components/TraineeDetails/TraineeDetailsEmployee/TraineeDetailsEmployee";
import ClassTrainerDetails from "components/TraineeDetails/ClassTrainer/TraineeDetailsClassTrainer";
import ProductTrainingDetails from "components/TraineeDetails/ProductTraining/TraineeDetailsProductTraining";
import TCITraineeDetails from "components/TraineeDetails/TCI/TraineeDetailsTCI";
import TTDTraineeDetails from "components/TraineeDetails/TTD/TTDTraineeDetails";
import TTFTraineeDetails from "components/TraineeDetails/TTF/TTFTraineeDetails";
import Box from "@mui/material/Box";
import BackdropComponent from "components/Spinner/Spinner";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const TraineeDetailsHome = () => {
  const { OracleId } = useParams();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [value, setValue] = React.useState(0);

  useEffect(() => {
    let cancelled = false;

    document.title = "Trainee Detail";

    const fetchData = async () => {
      if (!cancelled) {
        setLoader(true);
      }

      try {
        const result = await getTraineeDetails(OracleId);

        if (cancelled) return;

        if (!cancelled) {
          setData(result.data);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch trainee details:", error);
        }
      } finally {
        if (!cancelled) {
          setLoader(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [OracleId]);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {loader ? <BackdropComponent /> : null}
      <div className={"home-section"}>
        <div className={`${classes.traineeDetailsContainer} main-section`}>
          <TraineeDetailsSidebar data={data} />
          <div className={"info-section background-white"}>
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="EMPLOYEE" {...a11yProps(0)} />
                  <Tab label="CLASS/TRAINER" {...a11yProps(1)} />
                  <Tab label="TCI" {...a11yProps(2)} />
                  <Tab label="PRODUCT TRAINING" {...a11yProps(3)} />
                  <Tab label="TTF" {...a11yProps(4)} />
                  <Tab label="TTD" {...a11yProps(5)} />
                </Tabs>
              </Box>

              <div className={classes.components}>
                <TabPanel value={value} index={0}>
                  <EmployeeDetails data={data} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <ClassTrainerDetails data={data} />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <TCITraineeDetails data={data} />
                </TabPanel>
                {/* <TabPanel value={value} index={3}>
                <TPCTraineeDetails data={data} />
              </TabPanel> */}
                <TabPanel value={value} index={3}>
                  <ProductTrainingDetails data={data} />
                </TabPanel>
                <TabPanel value={value} index={4}>
                  <TTFTraineeDetails data={data} />
                </TabPanel>
                <TabPanel value={value} index={5}>
                  <TTDTraineeDetails data={data} />
                </TabPanel>
              </div>
            </Box>
          </div>
        </div>
      </div>
    </>
  );
};

export default TraineeDetailsHome;
